export default {
  deviceAuthorization: {
    createActivationCode: '生成激活码',
    activationDetail: '激活码详情',
    activationQrCode: '激活码二维码',
    downloadQrCode: '下载二维码',
    qrPlaceholder: '暂无二维码预览',
    quotaOverview: '可用额度',
    quotaOverviewDesc: '生成激活码会占用可用额度，作废或失效后仅返还未激活部分。',
    noQuotaData: '暂无额度数据',
    availableQuota: '可用额度',
    availableQuotaCount: '可用额度：{count}',
    basicInfo: '基础信息',
    selectDeviceQuota: '选择设备额度',
    selectedDeviceCount: '本次选择 {count} 台设备',
    quotaUsageTip: '生成激活码后占用对应设备类型额度，未激活部分在作废或失效后返还',
    deadlineHelp: '仅控制激活码失效日期，不是设备有效期；所选日期当天 23:59:59 前可激活。',
    plannedDeviceType: '规划中设备类型',
    planned: '规划中',
    windowsCashier: 'Windows 收银台',
    posMachine: 'POS机',
    gateMachine: '闸机',
    ticketMachine: '自助售票机',
    coinSaleMachine: '自助售币机',
    coinDepositMachine: '自助存币机',
    ticketDepositMachine: '自助存票机',
    vendingMachine: '自助售货机',
    activationCode: '激活码',
    activationShop: '激活门店',
    includedDevice: '包含设备',
    activationStatus: '激活状态',
    quantity: '数量',
    activatedQuantity: '已激活数量',
    quotaHandling: '额度处理',
    activatableDeadline: '可激活截止时间',
    createTime: '生成时间',
    deviceType: '设备类型',
    pendingActivation: '待激活',
    partialActivation: '部分激活',
    activated: '已激活',
    expired: '已失效',
    voided: '已作废',
    unknownStatus: '未知状态',
    unknownDeviceType: '未知设备类型',
    detail: '详情',
    qrCode: '二维码',
    qrUnavailable: '当前状态不支持查看或下载二维码',
    qrLoadFailed: '二维码加载失败，请稍后重试',
    listLoadFailed: '激活码列表加载失败，已保留当前数据',
    quotaLoadFailed: '额度数据加载失败，已保留当前数据',
    deviceTypeLoadFailed: '设备类型加载失败，请稍后重试',
    detailLoadFailed: '激活码详情加载失败，请稍后重试',
    voidActivationCode: '作废',
    voidConfirmTitle: '确认作废激活码',
    voidConfirmContent: '作废后未激活部分不可再激活，并返还对应额度；已激活设备不受影响。是否继续？',
    voidSuccess: '激活码已作废',
    voidFailed: '激活码作废失败，请稍后重试',
    frozenQuotaCount: '冻结 {count} 个',
    returnedQuotaCount: '返还 {count} 个',
    selectActivationShop: '请选择激活门店',
    systemGenerated: '系统自动生成',
    selectDeadline: '请选择可激活截止时间',
    createQuantity: '生成数量',
    quantityGreaterThanZero: '生成数量必须大于 0',
    selectAtLeastOneDevice: '请至少选择一种设备并填写生成数量',
    quantityExceedQuota: '生成数量不能超过可用额度',
    deadlineRangeTip: '截止日期必须在今天起 7 个自然日内（含今天）',
    invalidTimeRange: '开始时间不能晚于结束时间',
    createSuccess: '激活码生成成功',
    createFailed: '激活码生成失败，请稍后重试',
    activationDetailList: '激活明细',
    deviceCode: '设备编码',
    activatedTime: '激活时间',
    unbound: '已解绑',
  },
};
